module.exports = __webpack_public_path__ + "img/noPackage.c5c4cd93.png";